/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:56
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-12 10:02:14
 */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/util/request'
import user from './modules/user'
import getters from './getters'
import { burying } from '@/api'
// import regions from '@/config/regions'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user
  },
  getters,
  state: {
    lang: 'zh_tw',
    // region: window.sessionStorage.region || (regions && regions[0]),
    token: window.sessionStorage.token,
    isPc: undefined,
    thirdPartName: undefined
  },
  mutations: {
    CHANGE_LANG (state, lang) {
      axios.defaults.headers.common.lang = lang
      window.sessionStorage.lang = lang
      state.lang = lang
    },
    SET_TOKEN (state, token) {
      axios.defaults.headers.common['Access-Token'] = token
      window.sessionStorage.token = token
      state.token = token
    },
    SET_PC_STATUS (state, isPc) {
      state.isPc = isPc
    },
    SET_THIRD_PART_NAME (state, thirdPartName) {
      state.thirdPartName = thirdPartName
    }
    // CHANGE_REGION (state, region) {
    //   window.sessionStorage.region = region
    //   axios.defaults.headers.common.region = region
    //   state.region = region
    // }
  },
  actions: {
    UploadBurying ({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        burying(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
    // Logout ({ commit, state }) {
    //   commit('SET_TOKEN', null)
    // }
  }
})
